import { useQuery } from 'react-query'
import useAxios from './useAxios'

const useDefaultDetail = (serviceName, slug) => {
	const { getDefaultDetails } = useAxios()
	const { isLoading, data } = useQuery(`${serviceName}${slug}`, () =>
		getDefaultDetails(serviceName, slug),
	)

	if (isLoading) return { isLoading }

	return {
		isLoading,
		data,
	}
}

export default useDefaultDetail
